export const SET_CHARGEBACK_PAYMENTS = (state, payload) => {
 state.payments = payload;
}
